var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolanaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_222_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.59895 9.15899C2.6955 9.06659 2.82826 9.0127 2.96907 9.0127H15.7385C15.9718 9.0127 16.0885 9.28218 15.9236 9.44003L13.4011 11.8539C13.3045 11.9463 13.1717 12.0002 13.0309 12.0002H0.261506C0.0281642 12.0002 -0.0885066 11.7307 0.0764418 11.5728L2.59895 9.15899Z",
    fill: "url(#paint0_linear_222_39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.59895 0.146295C2.69952 0.053898 2.83229 0 2.96907 0H15.7385C15.9718 0 16.0885 0.26949 15.9236 0.427334L13.4011 2.84119C13.3045 2.93359 13.1717 2.98749 13.0309 2.98749H0.261506C0.0281642 2.98749 -0.0885066 2.718 0.0764418 2.56015L2.59895 0.146295Z",
    fill: "url(#paint1_linear_222_39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4011 4.62383C13.3045 4.53144 13.1717 4.47754 13.0309 4.47754H0.261506C0.0281642 4.47754 -0.0885066 4.74703 0.0764418 4.90487L2.59895 7.31873C2.6955 7.41113 2.82826 7.46503 2.96907 7.46503H15.7385C15.9718 7.46503 16.0885 7.19554 15.9236 7.03769L13.4011 4.62383Z",
    fill: "url(#paint2_linear_222_39)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_39",
    x1: 14.5186,
    y1: -1.44179,
    x2: 6.27728,
    y2: 15.0542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_222_39",
    x1: 10.6544,
    y1: -3.37253,
    x2: 2.41306,
    y2: 13.1235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_222_39",
    x1: 12.5742,
    y1: -2.41324,
    x2: 4.33286,
    y2: 14.0828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_222_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaIcon);
export default __webpack_public_path__ + "static/media/solanaIcon.8573442f01e06dc8f7a366baa40d6643.svg";
export { ForwardRef as ReactComponent };